var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBorderCornerTop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 145,
  height: 99,
  fill: "none",
  viewBox: "0 0 145 99"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#a)",
  strokeMiterlimit: 10,
  strokeWidth: 4.18,
  d: "M3.072 98.175V2.22h141.787"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 72.701,
  x2: 72.701,
  y1: 0.604,
  y2: 98.175,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#26F028"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#011F21"
})))));
export { SvgBorderCornerTop as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDUiIGhlaWdodD0iOTkiIHZpZXdCb3g9IjAgMCAxNDUgOTkiIGZpbGw9Im5vbmUiPgogIDxwYXRoIGQ9Ik0zLjA3MiA5OC4xNzUzTDMuMDcyIDIuMjIwMzNMMTQ0Ljg1OSAyLjIyMDM0IiBzdHJva2U9InVybCgjcGFpbnQwX2xpbmVhcl8xNV80MjcpIiBzdHJva2Utd2lkdGg9IjQuMTgiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgogIDxkZWZzPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzE1XzQyNyIgeDE9IjcyLjcwMTIiIHkxPSIwLjYwNDQ2MSIgeDI9IjcyLjcwMTIiIHkyPSI5OC4xNzUzIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMyNkYwMjgiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDExRjIxIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KPC9zdmc+";